import * as Yup from 'yup';
import { useState, useEffect } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { useFormik, Form, FormikProvider } from 'formik';
import { connect } from "react-redux";
import { Icon } from '@iconify/react';
import eyeFill from '@iconify/icons-eva/eye-fill';
import eyeOffFill from '@iconify/icons-eva/eye-off-fill';
// material
import {
    Link,
    Card,
    Stack,
    Checkbox,
    TextField,
    IconButton,
    InputAdornment,
    FormControlLabel,
    Container,
    Typography,
    TableContainer,
    Table,
    TableBody,
    TableRow,
    TableCell,
    TablePagination,
    Grid
} from '@mui/material';
import { ListHead, ListToolbar, MoreMenu } from '../../components/_dashboard/car';
import { LoadingButton } from '@mui/lab';
import Scrollbar from '../../components/Scrollbar';
import { fetchAllFinalInvoices, printInvoice } from '../../actions/finalInvoiceAction';
import _ from 'lodash';
import Page from '../../components/Page';
import { styled } from '@mui/material/styles';
import Edit from "@material-ui/icons/CloudDownload";
import DeleteOutlined from "@material-ui/icons/DeleteOutlined";
import ModalCompoennt from '../Portal/ModalCompoennt';
import DeleteFinalInvoice from './DeleteFinalInvoice';
import Pagination from '@mui/material/Pagination';


// ----------------------------------------------------------------------

const ContentStyle = styled('div')(({ theme }) => ({
    maxWidth: 680,
    margin: 'auto',
    minHeight: '100vh',
    flexDirection: 'column',
    justifyContent: 'center',
}));

const TABLE_HEAD = [
    { id: 'car_name', label: 'Car Name', alignRight: false },
    { id: 'buyer_name', label: 'Buyer Name', alignRight: false },
    { id: 'account_title', label: 'Account Title', alignRight: false },
    { id: 'bank_name', label: 'Bank Name', alignRight: false },
    { id: 'branch_name', label: 'Branch Name', alignRight: false },
    { id: 'actions', label: 'Action', alignRight: false },

];

function FinalInvoicesList(props) {
    const navigate = useNavigate();
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [adminObj, setAdminObj] = useState({});
    const [openUpdate, setOpenUpdate] = useState(false);
    const [addOpen, setAddOpen] = useState(false);
    const [updateOpen, setUpdateOpen] = useState(false);
    const [openDelete, setOpenDelete] = useState(false);
    const [accountObj, setAccountObj] = useState({});
    const [invoiceObj, setInvoiceObj] = useState({});

    useEffect(() => {
        setIsLoading(false);
    }, [props.alerts]);

    useEffect(() => {
        props.fetchAllFinalInvoices(page);
    }, []);

    const handleAddClick = () => {
        setAddOpen(true);
    }
    
    const closeButton = () => {
        setUpdateOpen(false);
        setAddOpen(false);
        setOpenDelete(false);
        setAccountObj({});
        setInvoiceObj({});
    }

    const handleDownloadClick = (i) => {
        const values = {};
        values.account_id = i.account.id;
        values.car_detail_id = i.car.id;
        return props.printInvoice(values);
    }

    const hanldeDeleteClick = (i) => {
        setOpenDelete(true);
        setInvoiceObj({invoiceObj:i});
    }

    const handlePageChange = (event, newPage) => {
        setPage(newPage);
        props.fetchAllFinalInvoices(newPage);
    }

    const renderInvoicesList = () => {
        if(!_.isEmpty(props.finalInvoices.data)) {
            var invoices = props.finalInvoices.data;
            var f_invoices = _.orderBy(invoices, ['id'], ['desc']);
            return f_invoices.map((i) => {
                return (
                    <TableRow
                        hover
                        tabIndex={-1}
                    >
                        <TableCell align="left" style={{padding:"10px"}}>{i.car.motor}</TableCell>
                        <TableCell align="left" style={{padding:"10px"}}>{i.car.buyer_name}</TableCell>
                        <TableCell align="left" style={{padding:"10px"}}>{i.account.title}</TableCell>
                        <TableCell align="left" style={{padding:"10px"}}>{i.account.bank_name}</TableCell>
                        <TableCell align="left" style={{padding:"10px"}}>{i.account.branch_name}</TableCell>
                        <TableCell colSpan={3}>
                        <IconButton sx={{float:"left",padding:"0px", color:"#c29136"}} onClick={() => handleDownloadClick(i)}>
                            <Edit />
                        </IconButton>
                        <IconButton sx={{float:"left",padding:"0px", color:"red"}} onClick={() => hanldeDeleteClick(i)}>
                            <DeleteOutlined />
                        </IconButton>
                        </TableCell>
                    </TableRow>
                );
            })
        } else {
            return <TableRow>
                <TableCell colSpan={6}>No Final Invoices Exist</TableCell>
            </TableRow>
        }
    }

    return (
        <Page title="Account List">
            <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
                <Grid>
                    <Typography variant="h4" gutterBottom>
                        Final Invoices List 
                    </Typography>
                </Grid>
            </Stack>
            <Card>
                <Scrollbar>
                    <TableContainer sx={{ minWidth: 800 }}>
                        <Table>
                            <ListHead
                                headLabel={TABLE_HEAD}
                                rowCount={props.finalInvoices.length}
                            />
                            <TableBody>
                                {renderInvoicesList()}
                            </TableBody>
                        </Table>
                        <Pagination sx={{float:"right",marginTop:"10px",marginBottom:"10px"}} page={page} count={props.finalInvoices.paginate.last_page} variant="outlined" color="primary" onChange={handlePageChange} />
                    </TableContainer>
                </Scrollbar>
            </Card>
            {
                openDelete &&
                <ModalCompoennt open={openDelete} onClose={closeButton} title="Delete" width="xs" color="red">
                    <DeleteFinalInvoice invoice={invoiceObj} onDismis={closeButton} />
                </ModalCompoennt>
            }
        </Page>
    );
}
const mapStateToProps = (state) => {
    return {
        auth: state.auth,
        alerts: state.alerts,
        finalInvoices: state.finalInvoices,
    }
}

export default connect(mapStateToProps, { fetchAllFinalInvoices, printInvoice })(FinalInvoicesList);

